<template>
  <div>
    <b-overlay :show="loading">
      <b-container fluid>
        <span 
          v-if="zaprosInfo"
          @click="visible = 'zapros'"
          :class="visible === 'zapros' ? 'order-service-menu mx-2 order-service-menu__active':'order-service-menu mx-2'"
        >Запрос на котировку</span>
        <span 
          v-if="obshayaInfo"
          @click="visible = 'obshaya'"
          :class="visible === 'obshaya' ? 'order-service-menu mx-2 order-service-menu__active':'order-service-menu mx-2'"
        >Общая информация</span>
        <span 
          v-if="etapyDvigeniya"
          @click="visible = 'etapy'"
          :class="visible === 'etapy' ? 'order-service-menu mx-2 order-service-menu__active':'order-service-menu mx-2'"
        >Этапы движения</span>
        <span 
          v-if="timelinePostavki"
          @click="visible = 'graph'"
          :class="visible === 'graph' ? 'order-service-menu mx-2 order-service-menu__active':'order-service-menu mx-2'"
        >Таймлайн поставки</span>
      </b-container>

      <div v-show="visible === 'zapros'">
        <b-card>
          <b-container fluid>
            <template v-if="detailedItem.quotation && detailedItem.quotation.data">
                <OrderServiceDeliveryQuotationInfo 
                    :quotation="detailedItem.quotation"
                    :showAnswers="true"
                />
            </template>
            <template v-else>
                <div style="font-style: italic; padding: 25px 15px">Запрос на котировку не составлялся.</div>
            </template>
          </b-container>
        </b-card>
      </div>

      <div v-show="visible === 'obshaya'">
        <b-card>
          <b-container fluid>
            <b-row class="my-2">
              <b-col sm="12" md="12">
                <b-row class="my-2">
                  <b-col sm="6" md="2">
                    <label for="nomer_of_dogovor">Номер договора:</label>
                  </b-col>
                  <b-col sm="6" md="4">
                    <b-form-input v-model="editedData['0'].value" size="sm" placeholder="" :disabled="true"></b-form-input>
                    <template v-if="editMode && filteredDocs.length > 0">
                      <div class="upDocSelectLinksHead mt-1 font-weight-bold">Выберите договор:</div>
                      <div 
                          v-for="doc in filteredDocs" 
                          @click="changeSelectedDoc(doc)"
                          :key="doc.id"
                          class="docSelectLinks"
                      >
                          {{ doc.name }} ({{ doc.date_of_document | formattedDate }})
                      </div>
                    </template>                                        
                    <template v-if="editMode && filteredDocs.length == 0">
                      <div class="upDocSelectLinksHead mt-1 font-weight-bold">Добавьте в компанию <br />хотя бы один договор ТЭО!</div>
                    </template>
                  </b-col>
                  <b-col sm="6" md="2">
                    <label for="data_of_dogovor">Дата договора:</label>
                  </b-col>
                  <b-col sm="6" md="4">
                    <b-form-input v-model="editedData['1'].value" type="date" size="sm" placeholder="" :disabled="true"></b-form-input>
                  </b-col>
                </b-row>
                <b-row class="my-2">
                  <b-col sm="2">
                    <label for="name_of_cargo">Наименование груза, код ТНВЭД:</label>
                  </b-col>
                  <b-col sm="10">
                    <b-form-input v-model="editedData['name_of_cargo']" name="name_of_cargo" size="sm" placeholder="" :disabled="!localEditMode"></b-form-input>
                  </b-col>
                </b-row>
                <b-row class="my-2">
                  <b-col sm="2">
                    <label for="import_export">Импорт / Экспорт:</label>
                  </b-col>
                  <b-col sm="4">
                    <b-form-select 
                      v-model="editedData['import_export']" 
                      name="import_export" 
                      size="sm" 
                      placeholder="" 
                      :options="[
                        { value: 'Импорт', text: 'Импорт' },
                        { value: 'Экспорт', text: 'Экспорт' }
                      ]"
                      :disabled="!localEditMode"
                    ></b-form-select>
                  </b-col>
                </b-row>                
                <b-row class="my-2">
                  <b-col sm="2">
                    <label for="usloviya_postavki_id">Условие поставки:</label>
                  </b-col>
                  <b-col sm="4">
                    <tsoft-select-of-properties
                      :reference_id="68"
                      :needNullElement="true"
                      :disabled="!localEditMode"
                      :selected="editedData['usloviya_postavki_id']"
                      index="usloviya_postavki_id"
                      @set="setReferenceValue"
                    ></tsoft-select-of-properties>  
                  </b-col>
                  <b-col sm="2">
                    <label for="naselenniy_punkt">Населенный пункт:</label>
                  </b-col>
                  <b-col sm="4">
                    <b-form-input v-model="editedData['naselenniy_punkt']" name="naselenniy_punkt" size="sm" placeholder="" :disabled="!localEditMode"></b-form-input>
                  </b-col>
                </b-row>                
              </b-col>
            </b-row>
            <b-row class="my-2">
              <b-col sm="12" md="6">
                <b-row class="my-2">
                  <b-col sm="4">
                    <label for="number_of_places">Кол-во мест:</label>
                  </b-col>
                  <b-col sm="8">
                    <b-form-input v-model="editedData['number_of_places']" type="number" name="number_of_places" size="sm" placeholder="" :disabled="!localEditMode"></b-form-input>
                  </b-col>
                </b-row>
                <b-row class="my-2">
                  <b-col sm="4">
                    <label for="weight">Вес, кг.:</label>
                  </b-col>
                  <b-col sm="8">
                    <b-form-input v-model="editedData['weight']" type="number" name="weight" size="sm" placeholder="" :disabled="!localEditMode"></b-form-input>
                  </b-col>
                </b-row>
                <b-row class="my-2">
                  <b-col sm="4">
                    <label for="volume">Объем, м<sup>3</sup>:</label>
                  </b-col>
                  <b-col sm="8">
                    <b-form-input v-model="editedData['volume']" type="number" name="volume" size="sm" placeholder="" :disabled="!localEditMode"></b-form-input>
                  </b-col>
                </b-row>
              </b-col>
              <b-col sm="12" md="6">
                <b-row class="my-2">
                  <b-col sm="4">
                    <label for="type_of_container_id">Тип контейнера:</label>
                  </b-col>
                  <b-col sm="8">
                    <tsoft-select-of-properties
                      :reference_id="56"
                      :needNullElement="true"
                      :disabled="!localEditMode"
                      :selected="editedData['type_of_container_id']"
                      index="type_of_container_id"
                      @set="setReferenceValue"
                    ></tsoft-select-of-properties>  
                  </b-col>
                </b-row>
                <b-row class="my-2">
                  <b-col sm="4">
                    <label for="number_of_container">Кол-во контейнеров:</label>
                  </b-col>
                  <b-col sm="8">
                    <b-form-input v-model="editedData['number_of_container']" type="number" name="number_of_container" size="sm" placeholder="" :disabled="!localEditMode"></b-form-input>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </b-container>
          <hr>
          <b-container fluid class="mt-3">
            <b-row class="my-2 mb-3">
              <b-col sm="12" md="12">
                <b-row class="my-2">
                  <b-col sm="2">
                    <label for="sales_name">Продавец:</label>
                  </b-col>
                  <b-col sm="10">
                    <b-form-input v-model="editedData['sales_name']" name="sales_name" size="sm" placeholder="" :disabled="!localEditMode"></b-form-input>
                  </b-col>
                </b-row>
                <b-row class="my-2">
                  <b-col sm="2">
                    <label for="cargo_sender_name">Грузоотправитель:</label>
                  </b-col>
                  <b-col sm="10">
                    <b-form-input v-model="editedData['cargo_sender_name']" name="cargo_sender_name" size="sm" placeholder="" :disabled="!localEditMode"></b-form-input>
                  </b-col>
                </b-row>
                <b-row class="my-2">
                  <b-col sm="2">
                    <label for="address_g_o">Адрес ГО:</label>
                  </b-col>
                  <b-col sm="10">
                    <b-form-input v-model="editedData['address_g_o']" name="address_g_o" size="sm" placeholder="" :disabled="!localEditMode"></b-form-input>
                  </b-col>
                </b-row>
                <b-row class="my-2">
                  <b-col sm="2">
                    <label for="contact_name_on_shipment">Контактное лицо на погрузке, телефон:</label>
                  </b-col>
                  <b-col sm="10">
                    <b-form-input v-model="editedData['contact_name_on_shipment']" name="contact_name_on_shipment" size="sm" placeholder="" :disabled="!localEditMode"></b-form-input>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
            <b-row class="my-2 mb-3">
              <b-col sm="12" md="12">
                <b-row class="my-2">
                  <b-col sm="2">
                    <label for="cargo_recipient_name">Грузополучатель:</label>
                  </b-col>
                  <b-col sm="10">
                    <b-form-input v-model="editedData['cargo_recipient_name']" name="cargo_recipient_name" size="sm" placeholder="" :disabled="!localEditMode"></b-form-input>
                  </b-col>
                </b-row>
                <b-row class="my-2">
                  <b-col sm="2">
                    <label for="address_g_p">Адрес ГП:</label>
                  </b-col>
                  <b-col sm="10">
                    <b-form-input v-model="editedData['address_g_p']" name="address_g_p" size="sm" placeholder="" :disabled="!localEditMode"></b-form-input>
                  </b-col>
                </b-row>
                <b-row class="my-2">
                  <b-col sm="2">
                    <label for="address_of_unloading">Адрес разгрузки:</label>
                  </b-col>
                  <b-col sm="10">
                    <b-form-input v-model="editedData['address_of_unloading']" name="address_of_unloading" size="sm" placeholder="" :disabled="!localEditMode"></b-form-input>
                  </b-col>
                </b-row>
                <b-row class="my-2">
                  <b-col sm="2">
                    <label for="contact_name_on_unloading">Контактное лицо на разгрузке, телефон:</label>
                  </b-col>
                  <b-col sm="10">
                    <b-form-input v-model="editedData['contact_name_on_unloading']" name="contact_name_on_unloading" size="sm" placeholder="" :disabled="!localEditMode"></b-form-input>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </b-container>
          <hr>
          <b-container fluid>
            <b-row class="my-2">
              <b-col sm="2">
                <label for="perevozchik_id">Перевозчик:</label>
              </b-col>
              <b-col sm="10">
                <tsoft-select-company
                  :needNullElement="true"
                  :selected="editedData['perevozchik_id']"
                  :disabled="!localEditMode"
                  :additionalGetParams="`&is_transport_company=1&checked_id=444`"
                  @set="setCompanyPerevozchikOfOrder"
                ></tsoft-select-company>
              </b-col>
            </b-row>
            <b-row class="my-2">
                <b-col sm="0" md="2"></b-col>
                <b-col sm="12" md="5">                
                  <b-row class="my-2">
                    <b-col sm="4">
                      <label for="perevozchik_name">Перевозчик. Наименование:</label>
                    </b-col>
                    <b-col sm="8">
                      <b-form-input 
                          v-model="editedData['perevozchik_name']" 
                          name="perevozchik_name" 
                          size="sm" 
                          placeholder="" 
                          :disabled="true"
                      ></b-form-input>
                    </b-col>
                  </b-row>
                </b-col>
                <b-col sm="12" md="5">
                  <b-row class="my-2">
                    <b-col sm="4">
                      <label for="perevozchik_inn">Перевозчик. ИНН:</label>
                    </b-col>
                    <b-col sm="8">
                      <b-form-input 
                          v-model="editedData['perevozchik_inn']" 
                          name="perevozchik_inn" 
                          size="sm" 
                          placeholder="" 
                          :disabled="true"
                      ></b-form-input>
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>
              <b-row class="my-2">
                <b-col sm="0" md="2"></b-col>
                <b-col sm="12" md="10">
                  <b-row class="my-2">
                    <b-col sm="2">
                      <label for="perevozchik_uridicheskiy_address">Перевозчик. Юр. адрес:</label>
                    </b-col>
                    <b-col sm="10">
                      <b-form-input 
                          v-model="editedData['perevozchik_uridicheskiy_address']" 
                          name="perevozchik_uridicheskiy_address" 
                          size="sm" 
                          placeholder="" 
                          :disabled="true"
                      ></b-form-input>
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>  
          </b-container>
          <hr>
          <b-container fluid>
            <b-row class="my-2">
              <b-col sm="12" md="6">
                <b-row class="my-2">
                  <b-col sm="4">
                    <label for="station_of_otpravleniya">Станция отправления:</label>
                  </b-col>
                  <b-col sm="8">
                    <b-form-input v-model="editedData['station_of_otpravleniya']" name="station_of_otpravleniya" size="sm" placeholder="" :disabled="!localEditMode"></b-form-input>
                  </b-col>
                </b-row>
                <b-row class="my-2">
                  <b-col sm="4">
                    <label for="station_of_incoming_id">Станция назначения:</label>
                  </b-col>
                  <b-col sm="8">
                    <tsoft-select-of-properties
                      :reference_id="70"
                      :excludeArray="[888]"
                      :needNullElement="true"
                      :disabled="!localEditMode"
                      :selected="editedData['station_of_incoming_id']"
                      index="station_of_incoming_id"
                      @set="setReferenceValue"
                    ></tsoft-select-of-properties>  
                  </b-col>
                </b-row>
                <b-row class="my-2">
                  <b-col sm="4">
                    <label for="pogranichnie_stancii_perehodov">Пограничные станции переходов:</label>
                  </b-col>
                  <b-col sm="8">
                    <tsoft-select-of-properties
                      :reference_id="73"
                      :needNullElement="true"
                      :disabled="!localEditMode"
                      :selected="editedData['pogranichnie_stancii_perehodov']"
                      index="pogranichnie_stancii_perehodov"
                      @set="setReferenceValue"
                    ></tsoft-select-of-properties>  
                  </b-col>
                </b-row>
              </b-col>
              <b-col sm="12" md="6">
                <b-row class="my-2">
                  <b-col sm="4">
                    <label for="nomer_of_container">№ контейнера:</label>
                  </b-col>
                  <b-col sm="8">
                    <b-form-input v-model="editedData['nomer_of_container']" name="nomer_of_container" size="sm" placeholder="" :disabled="!localEditMode"></b-form-input>
                  </b-col>
                </b-row>
                <b-row class="my-2">
                  <b-col sm="4">
                    <label for="nomer_smgs">Номер СМГС:</label>
                  </b-col>
                  <b-col sm="8">
                    <b-form-input v-model="editedData['nomer_smgs']" name="nomer_smgs" size="sm" placeholder="" :disabled="!localEditMode"></b-form-input>
                  </b-col>
                </b-row>
                <b-row class="my-2">
                  <b-col sm="4">
                    <label for="data_vypuska_smgs">Дата выпуска СМГС:</label>
                  </b-col>
                  <b-col sm="8">
                    <b-form-input v-model="editedData['data_vypuska_smgs']" name="data_vypuska_smgs" type="date" size="sm" placeholder="" :disabled="!localEditMode"></b-form-input>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </b-container>
        </b-card>
      </div>

      <div v-show="visible === 'etapy'">
        <b-card>
          <b-container fluid>
            <b-row class="my-2">
              <b-col sm="12" md="12">
                <b-row class="my-2">
                  <b-col sm="2">
                    <label for="name_of_cargo">Маршрут</label>
                  </b-col>
                  <b-col sm="10">
                    <b-list-group horizontal="md">
                      <b-list-group-item variant="secondary">
                        <span class="small-description">условия поставки</span>
                        {{ nameByPropId(editedData.usloviya_postavki_id) || '<Укажите условия поставки>' }} / {{ nameByPropId(editedData.type_of_container_id) || '<Укажите тип контейнера>' }}
                      </b-list-group-item>
                      <b-list-group-item :variant="variantByTwoDays(editedData['zatarka_containera_plan'], editedData['zatarka_containera_fact'])">
                        <span class="small-description">адрес погрузки</span>
                        {{ editedData.naselenniy_punkt || '<Укажите населенный пункт>' }}<br>
                        <small>{{ editedData['zatarka_containera_fact'] || editedData['zatarka_containera_plan'] || '<Даты нет>' | formattedDate }}</small>
                      </b-list-group-item>
                      <b-list-group-item :variant="variantByTwoDays(editedData['vihod_poezda_so_stancii_otpravleniya_plan'], editedData['vihod_poezda_so_stancii_otpravleniya_fact'])">
                        <span class="small-description">станция отправления</span>
                        {{ editedData.station_of_otpravleniya || '<Укажите станцию отправления>' }}<br>
                        <small>{{ editedData['vihod_poezda_so_stancii_otpravleniya_fact'] || editedData['vihod_poezda_so_stancii_otpravleniya_plan'] || '<Даты нет>' | formattedDate }}</small>
                      </b-list-group-item>
                      <b-list-group-item :variant="variantByTwoDays(editedData['vyhod_poezda_s_pp_plan'], editedData['vyhod_poezda_s_pp_fact'])">
                        <span class="small-description">погран переход</span>
                        {{ nameByPropId(editedData.pogranichnie_stancii_perehodov) || '<Укажите пограничные станции>' }}<br>
                        <small>{{ editedData['vyhod_poezda_s_pp_fact'] || editedData['vyhod_poezda_s_pp_plan'] || '<Даты нет>' | formattedDate }}</small>
                      </b-list-group-item>
                      <b-list-group-item :variant="variantByTwoDays(editedData['pribitie_poezda_na_stanciyu_nazanacheniya_plan'], editedData['pribitie_poezda_na_stanciyu_nazanacheniya_fact'])">
                        <span class="small-description">станция прибытия</span>
                        {{ nameByPropId(editedData.station_of_incoming_id) || '<Укажите станцию прибытия>' }}<br>
                        <small>{{ editedData['pribitie_poezda_na_stanciyu_nazanacheniya_fact'] || editedData['pribitie_poezda_na_stanciyu_nazanacheniya_plan'] || '<Даты нет>' | formattedDate }}</small>
                      </b-list-group-item>
                      <b-list-group-item :variant="variantByTwoDays(editedData['dostavka_plan'], editedData['dostavka_fact'])">
                        <span class="small-description">адрес разгрузки</span>
                        {{ editedData.address_of_unloading || '<Укажите адрес разгрузки>' }}<br>
                        <small>{{ editedData['dostavka_fact'] || editedData['dostavka_plan'] || '<Даты нет>' | formattedDate }}</small>
                      </b-list-group-item>
                    </b-list-group>                    
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
            <hr>
            <b-row class="my-2">
              <b-col sm="12" md="8">
                <b-row class="my-2">
                  <b-col sm="4">
                  </b-col>
                  <b-col sm="4" class="text-center">
                    План
                  </b-col>
                  <b-col sm="4" class="text-center">
                    Факт
                  </b-col>
                </b-row>
                <b-row class="my-2">
                  <b-col sm="4">
                    <label for="gotovnost_gruza_plan">Готовность груза:</label>
                  </b-col>
                  <b-col sm="4">
                    <b-form-input 
                        v-model="editedData['gotovnost_gruza_plan']" 
                        name="gotovnost_gruza_plan" 
                        type="date" 
                        size="sm" 
                        placeholder="" 
                        :disabled="!localEditMode"
                    ></b-form-input>
                  </b-col>
                  <b-col sm="4">
                    <b-form-input 
                        v-model="editedData['gotovnost_gruza_fact']" 
                        name="gotovnost_gruza_fact" 
                        type="date" 
                        size="sm" 
                        placeholder="" 
                        :disabled="!localEditMode"
                    ></b-form-input>
                  </b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col class="bg-gray-right">
                        <div class="details-group">
                            <div class="value-of-field">
                              <div class="table-document-correction">
                                <div class="text-uppercase">
                                    <div>
                                        <i v-if="editedData['cargo_sender_name']" class="bx bx-check text-success mr-2"></i>
                                        <i v-if="!editedData['cargo_sender_name']" class="bx bx-x text-danger mr-2"></i>
                                        Грузоотправитель
                                    </div>
                                    <div>
                                        <i v-if="editedData['address_g_o']" class="bx bx-check text-success mr-2"></i>
                                        <i v-if="!editedData['address_g_o']" class="bx bx-x text-danger mr-2"></i>
                                        Адрес ГО
                                    </div>
                                    <div>
                                        <i v-if="editedData['contact_name_on_shipment']" class="bx bx-check text-success mr-2"></i>
                                        <i v-if="!editedData['contact_name_on_shipment']" class="bx bx-x text-danger mr-2"></i>
                                        Контактное лицо на погрузке
                                    </div>
                                    <div>
                                        <i v-if="editedData['cargo_recipient_name']" class="bx bx-check text-success mr-2"></i>
                                        <i v-if="!editedData['cargo_recipient_name']" class="bx bx-x text-danger mr-2"></i>
                                        Грузополучатель
                                    </div>
                                    <div>
                                        <i v-if="editedData['address_g_p']" class="bx bx-check text-success mr-2"></i>
                                        <i v-if="!editedData['address_g_p']" class="bx bx-x text-danger mr-2"></i>
                                        Адрес ГП
                                    </div>
                                    <div>
                                        <i v-if="editedData['address_of_unloading']" class="bx bx-check text-success mr-2"></i>
                                        <i v-if="!editedData['address_of_unloading']" class="bx bx-x text-danger mr-2"></i>
                                        Адрес разгрузки
                                    </div>
                                    <div>
                                        <i v-if="editedData['contact_name_on_unloading']" class="bx bx-check text-success mr-2"></i>
                                        <i v-if="!editedData['contact_name_on_unloading']" class="bx bx-x text-danger mr-2"></i>
                                        Контактное лицо на разгрузке
                                    </div>
                                    <div>
                                        <i v-if="editedData['perevozchik_name'] &&
                                                 editedData['perevozchik_inn'] &&
                                                 editedData['perevozchik_uridicheskiy_address']" class="bx bx-check text-success mr-2"></i>
                                        <i v-if="!editedData['perevozchik_name'] ||
                                                 !editedData['perevozchik_inn'] ||
                                                 !editedData['perevozchik_uridicheskiy_address']" class="bx bx-x text-danger mr-2"></i>
                                        Данные по перевозчику
                                    </div>
                                    <div>
                                        <i v-if="editedData['pogranichnie_stancii_perehodov']" class="bx bx-check text-success mr-2"></i>
                                        <i v-if="!editedData['pogranichnie_stancii_perehodov']" class="bx bx-x text-danger mr-2"></i>
                                        Данные по пограничным станциям переходов
                                    </div>
                                    <div>
                                        <i v-if="hasDocumentWithId339" class="bx bx-check text-success mr-2"></i>
                                        <i v-if="!hasDocumentWithId339" class="bx bx-x text-danger mr-2"></i>
                                        В документах «Заявка на перевозку»
                                    </div>
                                </div>
                              </div>
                            </div>
                            <div class="descr-of-field">Для проставления готовности груза, заполните поля, добавьте документы.</div>
                        </div>
                    </b-col>
                </b-row>

                <b-row class="my-2">
                  <b-col sm="4">
                    <label for="zatarka_containera_plan">Затарка контейнера:</label>
                  </b-col>
                  <b-col sm="4">
                    <b-form-input 
                        v-model="editedData['zatarka_containera_plan']" 
                        name="zatarka_containera_plan" 
                        type="date" 
                        size="sm" 
                        placeholder="" 
                        :disabled="!localEditMode"
                    ></b-form-input>
                  </b-col>
                  <b-col sm="4">
                    <b-form-input 
                        v-model="editedData['zatarka_containera_fact']" 
                        name="zatarka_containera_fact" 
                        type="date" 
                        size="sm" 
                        placeholder="" 
                        :disabled="!localEditMode"
                    ></b-form-input>
                  </b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col class="bg-gray-right">
                        <div class="details-group">
                            <div class="value-of-field">
                              <div class="table-document-correction">
                                <div class="text-uppercase">
                                    <div>
                                        <i v-if="hasDocumentWithId339" class="bx bx-check text-success mr-2"></i>
                                        <i v-if="!hasDocumentWithId339" class="bx bx-x text-danger mr-2"></i>
                                        Заявка на перевозку
                                    </div>
                                    <div>
                                        <i v-if="hasDocumentWithId353" class="bx bx-check text-success mr-2"></i>
                                        <i v-if="!hasDocumentWithId353" class="bx bx-x text-danger mr-2"></i>
                                        Страховой полис
                                    </div>
                                </div>
                              </div>
                            </div>
                            <div class="descr-of-field">Для проставления затарки контейнера, добавьте документы.</div>
                        </div>
                    </b-col>
                </b-row>

                <b-row class="my-2">
                  <b-col sm="4">
                    <label for="vihod_poezda_so_stancii_otpravleniya_plan">Выход поезда со станции отправления:</label>
                  </b-col>
                  <b-col sm="4">
                    <b-form-input v-model="editedData['vihod_poezda_so_stancii_otpravleniya_plan']" name="vihod_poezda_so_stancii_otpravleniya_plan" type="date" size="sm" placeholder="" :disabled="!localEditMode"></b-form-input>
                  </b-col>
                  <b-col sm="4">
                    <b-form-input v-model="editedData['vihod_poezda_so_stancii_otpravleniya_fact']" name="vihod_poezda_so_stancii_otpravleniya_fact" type="date" size="sm" placeholder="" :disabled="!localEditMode"></b-form-input>
                  </b-col>
                </b-row>
                <b-row class="my-2">
                  <b-col sm="4">
                    <label for="pribitie_poezda_na_pp_plan">Прибытие поезда на ПП:</label>
                  </b-col>
                  <b-col sm="4">
                    <b-form-input v-model="editedData['pribitie_poezda_na_pp_plan']" name="pribitie_poezda_na_pp_plan" type="date" size="sm" placeholder="" :disabled="!localEditMode"></b-form-input>
                  </b-col>
                  <b-col sm="4">
                    <b-form-input v-model="editedData['pribitie_poezda_na_pp_fact']" name="pribitie_poezda_na_pp_fact" type="date" size="sm" placeholder="" :disabled="!localEditMode"></b-form-input>
                  </b-col>
                </b-row>
                <b-row class="my-2">
                  <b-col sm="4">
                    <label for="vyhod_poezda_s_pp_plan">Выход поезда с ПП:</label>
                  </b-col>
                  <b-col sm="4">
                    <b-form-input v-model="editedData['vyhod_poezda_s_pp_plan']" name="vyhod_poezda_s_pp_plan" type="date" size="sm" placeholder="" :disabled="!localEditMode"></b-form-input>
                  </b-col>
                  <b-col sm="4">
                    <b-form-input v-model="editedData['vyhod_poezda_s_pp_fact']" name="vyhod_poezda_s_pp_fact" type="date" size="sm" placeholder="" :disabled="!localEditMode"></b-form-input>
                  </b-col>
                </b-row>
                <b-row class="my-2">
                  <b-col sm="4">
                    <label for="pribitie_poezda_na_stanciyu_nazanacheniya_plan">Прибытие поезда на станцию назначения:</label>
                  </b-col>
                  <b-col sm="4">
                    <b-form-input v-model="editedData['pribitie_poezda_na_stanciyu_nazanacheniya_plan']" name="pribitie_poezda_na_stanciyu_nazanacheniya_plan" type="date" size="sm" placeholder="" :disabled="!localEditMode"></b-form-input>
                  </b-col>
                  <b-col sm="4">
                    <b-form-input v-model="editedData['pribitie_poezda_na_stanciyu_nazanacheniya_fact']" name="pribitie_poezda_na_stanciyu_nazanacheniya_fact" type="date" size="sm" placeholder="" :disabled="!localEditMode"></b-form-input>
                  </b-col>
                </b-row>
              </b-col>
              <b-col sm="12" md="4" class="text-center">
                <label>Транзитное время:</label>
                <div>{{ editedData['naselenniy_punkt'] || '<Укажите населенный пункт>' }} - {{ nameByPropId(editedData['station_of_incoming_id']) || '<Укажите станцию назначения>' }}</div>
                <div class="bigNumber">{{ transitnoe_vremya }}</div>
              </b-col>
            </b-row>
            <b-row class="my-2">
              <b-col sm="12" md="8">
                <b-row class="my-2">
                  <b-col sm="4">
                    <label for="zakritie_dostavki_plan">Закрытие доставки:</label>
                  </b-col>
                  <b-col sm="4">
                    <b-form-input v-model="editedData['zakritie_dostavki_plan']" name="zakritie_dostavki_plan" type="date" size="sm" placeholder="" :disabled="!localEditMode"></b-form-input>
                  </b-col>
                  <b-col sm="4">
                    <b-form-input v-model="editedData['zakritie_dostavki_fact']" name="zakritie_dostavki_fact" type="date" size="sm" placeholder="" :disabled="!localEditMode"></b-form-input>
                  </b-col>
                </b-row>
                <b-row class="my-2">
                  <b-col sm="4">
                    <label for="podacha_dt_plan">Подача ДТ:</label>
                  </b-col>
                  <b-col sm="4">
                    <b-form-input v-model="editedData['podacha_dt_plan']" name="podacha_dt_plan" type="date" size="sm" placeholder="" :disabled="!localEditMode"></b-form-input>
                  </b-col>
                  <b-col sm="4">
                    <b-form-input v-model="editedData['podacha_dt_fact']" name="podacha_dt_fact" type="date" size="sm" placeholder="" :disabled="!localEditMode"></b-form-input>
                  </b-col>
                </b-row>
                <b-row class="my-2">
                  <b-col sm="4">
                    <label for="vypusk_dt_plan">Выпуск ДТ:</label>
                  </b-col>
                  <b-col sm="4">
                    <b-form-input v-model="editedData['vypusk_dt_plan']" name="vypusk_dt_plan" type="date" size="sm" placeholder="" :disabled="!localEditMode"></b-form-input>
                  </b-col>
                  <b-col sm="4">
                    <b-form-input v-model="editedData['vypusk_dt_fact']" name="vypusk_dt_fact" type="date" size="sm" placeholder="" :disabled="!localEditMode"></b-form-input>
                  </b-col>
                </b-row>
              </b-col>
              <b-col sm="12" md="4" class="text-center">
                <label>Время ТО:</label>
                <div class="bigNumber">{{ time_of_to }}</div>
              </b-col>
            </b-row>

            <b-row class="my-2">
              <b-col sm="12" md="8">
                <b-row class="my-2">
                  <b-col sm="4">
                    <label for="dostavka_plan">Доставка до склада клиента:</label>
                  </b-col>
                  <b-col sm="4">
                    <b-form-input v-model="editedData['dostavka_plan']" name="dostavka_plan" type="date" size="sm" placeholder="" :disabled="!localEditMode"></b-form-input>
                  </b-col>
                  <b-col sm="4">
                    <b-form-input v-model="editedData['dostavka_fact']" name="dostavka_fact" type="date" size="sm" placeholder="" :disabled="!localEditMode"></b-form-input>
                  </b-col>
                </b-row>
              </b-col>
              <b-col sm="12" md="4" class="text-center"></b-col>
            </b-row>

            <hr>
            <b-row class="my-2">
              <b-col sm="12" class="text-center">
                <div class="bigNumber transitItogBlock">Общее транзитное время: {{ obshee_transitnoe_vremya }}</div>
              </b-col>
            </b-row>

          </b-container>
          
        </b-card>
      </div>

      <ActiveHistory
        v-if="visible === 'graph'"
        :serviceIds="detailedItem.id"
      />
    </b-overlay>
  </div>
</template>

<script>
import OrderServiceDeliveryQuotationInfo from '@/components/orders/orderServiceQuotation/OrderServiceDeliveryQuotationInfo.vue';
import ActiveHistory from '@/components/orders/orderServiceTemplate/v2/ActiveHistory';
import {
  constantsAllReferenceProperties,
  dateHelpers,
  dataHelpers
} from '@/mixins';

export default {
  props: {
    editMode: {
      type: Boolean,
      default: false,
    },
    saveMode: {
      type: Boolean,
      default: false,
    },
    detailedItem: {
      type: Object,
      required: true,
    },
    filteredDocs: {
      type: Array,
      required: true,
    },
    zaprosInfo: {
      type: Boolean,
      default: true,
    },
    obshayaInfo: {
      type: Boolean,
      default: true,
    },
    etapyDvigeniya: {
      type: Boolean,
      default: true,
    },
    timelinePostavki: {
      type: Boolean,
      default: true,
    },
    defaultVisible: {
      type: String,
      default: 'obshaya',
    },
  },
  mixins: [
    constantsAllReferenceProperties,
    dateHelpers,
    dataHelpers
  ],
  components: {ActiveHistory, OrderServiceDeliveryQuotationInfo},
  data() {
    return {
      loading: false,
      localEditMode: false,
      visible: 'obshaya',
      editedData: {
        "0": { value: '' },
        "1": { value: '' },
        name_of_cargo: '',
        import_export: 'Импорт',
        usloviya_postavki_id: null,
        naselenniy_punkt: '',
        number_of_places: 0,
        weight: 0,
        volume: 0,
        type_of_container_id: null,
        number_of_container: 1,
        sales_name: '',
        cargo_sender_name: '',
        address_g_o: '',
        contact_name_on_shipment: '',
        cargo_recipient_name: '',
        address_g_p: '',
        address_of_unloading: '',
        contact_name_on_unloading: '',
        station_of_otpravleniya: '',
        station_of_incoming_id: null,
        pogranichnie_stancii_perehodov: '',
        nomer_of_container: '',
        nomer_smgs: '',
        data_vypuska_smgs: '',

        perevozchik_id: null,
        perevozchik_name: '',
        perevozchik_inn: '',
        perevozchik_uridicheskiy_address: '',

        gotovnost_gruza_plan: '',
        gotovnost_gruza_fact: '',
        zatarka_containera_plan: '',
        zatarka_containera_fact: '',
        vihod_poezda_so_stancii_otpravleniya_plan: '',
        vihod_poezda_so_stancii_otpravleniya_fact: '',
        pribitie_poezda_na_pp_plan: '',
        pribitie_poezda_na_pp_fact: '', 
        vyhod_poezda_s_pp_plan: '',
        vyhod_poezda_s_pp_fact: '',
        pribitie_poezda_na_stanciyu_nazanacheniya_plan: '',
        pribitie_poezda_na_stanciyu_nazanacheniya_fact: '',
        transitnoe_vremya: '',

        zakritie_dostavki_plan: '',
        zakritie_dostavki_fact: '',
        podacha_dt_plan: '',
        podacha_dt_fact: '',
        vypusk_dt_plan: '',
        vypusk_dt_fact: '',
        time_of_to: '',

        dostavka_plan: '',
        dostavka_fact: '',
        obshee_transitnoe_vremya: ''
      },
    };
  },  
  computed: {
    transitnoe_vremya() {
      if (!this.editedData['pribitie_poezda_na_stanciyu_nazanacheniya_fact'] || !this.editedData['zatarka_containera_fact']) {
        return '<Расчет недоступен>';
      } 

      const transitnoe_vremya = this.getDiffNumberOfDays(this.editedData['zatarka_containera_fact'], this.editedData['pribitie_poezda_na_stanciyu_nazanacheniya_fact']);
      return transitnoe_vremya;      
    },
    time_of_to() {
      if (!this.editedData['vypusk_dt_fact'] || !this.editedData['podacha_dt_fact']) {
        // return 'Заполните поля <Выпуск ДТ> и <Подача ДТ>';
        return "<Расчет недоступен>";
      } 

      const time_of_to = this.getDiffNumberOfDays(this.editedData['podacha_dt_fact'], this.editedData['vypusk_dt_fact']);
      return time_of_to;
    },
    obshee_transitnoe_vremya() {
      if (!this.editedData['zatarka_containera_fact'] || !this.editedData['dostavka_fact']) {
        return '<Расчет недоступен>';
      } 

      const transitnoe_vremya = this.getDiffNumberOfDays(this.editedData['zatarka_containera_fact'], this.editedData['dostavka_fact']);
      return transitnoe_vremya;      
    },
    hasDocumentWithId339() {
        const hasDocumentWithId339 = this.detailedItem.documents && 
            this.detailedItem.documents.some(document => document.reference_document_type_id === 339);

        return hasDocumentWithId339;
    },
    hasDocumentWithId353() {
        const hasDocumentWithId353 = this.detailedItem.documents && 
            this.detailedItem.documents.some(document => document.reference_document_type_id === 353);

        return hasDocumentWithId353;
    },
    isCanFillGotovnostGruza() {
        return true;
    }
  },
  watch: {
    editMode: {
      handler(value) {
        this.localEditMode = value;
      },
      immediate: true
    },
    saveMode: {
      handler(value) {
        if (value == true) {
          this.$emit('updateData', this.editedData);
        }
      },
      immediate: true
    },
    detailedItem: {
      handler(data) {
        this.editedData = this.deepMergeSafeFirst(JSON.parse(JSON.stringify(data.data)), JSON.parse(JSON.stringify(this.editedData)));
      },
      deep: true,
      immediate: true
    },
    transitnoe_vremya(value) {
      this.editedData['transitnoe_vremya'] = value;
    },
    time_of_to(value) {
      this.editedData['time_of_to'] = value;
    },
    obshee_transitnoe_vremya(value) {
      this.editedData['obshee_transitnoe_vremya'] = value;
    }    
  },
  methods: {
    setReferenceValue(value, reference_id, index) {
      this.editedData[index] = value;
    },  
    setCompanyPerevozchikOfOrder(value, element) {
      this.editedData['perevozchik_id'] = value;
      this.editedData['perevozchik_name'] = element.name;
      this.editedData['perevozchik_inn'] = element.inn;
      this.editedData['perevozchik_uridicheskiy_address'] = element.address;
    },
    changeSelectedDoc(doc) {
      this.editedData[0].value = doc.name;
      this.editedData[1].value = doc.date_of_document;
    },    
  },

  mounted() {
    this.visible = this.defaultVisible;
  },
};
</script>
<style scoped>
.custom-select {
  height: 34px !important;
  border-radius: 3px !important;
  padding: 1px 8px;
}
.small-description {
  line-height: 11px;
}

</style>